<template>
  <div v-loading="loading">

    <el-dialog class="participant-dialog" :show-close="false" :title="$t('SELECT_PARTICIPANT')" :visible.sync="showPicker"
      width="90%" center custom-class="round-dialog">
      <div class="name-card-panel">
        <div class="name-card" v-for="item in showRelationList" :key="item.value">
          <br />
          <el-button type="primary" class="name-btn" @click="confirmPicker(item)"> {{ item.label }} </el-button>
          <br />

        </div>
      </div>

    </el-dialog>

    <el-card v-show="!showPicker">

      <el-row class="description">
        <h3>{{ $t('START_BTN_ENQUIRY') }}</h3>
      </el-row>

      <div style="min-height: 80px;">
        <el-select v-show="showRelationList" v-model="cid" :placeholder="$t('SELECT_PARTICIPANT')" class="child-select"
          popper-class="child-dropdown" @focus="showPicker = true" style="margin-bottom: 15px;">
          <el-option v-for="item in showRelationList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <div v-if="profile.address">
          <el-card class="enquiry-card" shadow="never">
            <p class="label">{{ $t("ENQUIRY_MODIFY_DATE") }}</p>
            <p><el-input :readonly="true" :value="profile.createDate"></el-input></p>
            <p class="label">{{ $t("ENQUIRY_ADDRESS") }}</p>
            <p><el-input :readonly="true" :value="profile.address" type="textarea" :autosize="true"
                resize="none"></el-input></p>
            <p class="label">{{ $t("ENQUIRY_DEPTS") }}</p>
            <p>

              <el-card class="dept-list-box">
                <ul class="dept-list">
                  <li v-for="dept in showDeptList" :key="dept.id">
                    {{ dept.text }}
                  </li>
                </ul>
              </el-card>
            </p>
          </el-card>
        </div>
        <div v-else>
          <p class="label" v-show="!loading">{{ $t('NO_DATA') }}</p>
        </div>
      </div>
      <br />
      <el-button class="gradient-button2" @click="backToStart" type="danger" block>
        {{ $t("back") }}
      </el-button>


    </el-card>

  </div>
</template>

<script>
import { getLocale } from "@/i18n.js";
import { enquiry, getDeptData } from "../api/contact.js";

export default {
  data() {
    return {
      fullDeptList: [],
      loading: true,
      profile: {
        createDate: "",
        address: "",
        selectedDepts: [],
        relations: undefined,
      },
      showRelationList: [],
      showDeptList: [],
      cid: undefined,
      showPicker: false,
      
    };
  },
  watch: {
    "$i18n.locale": function (newVal, oldVal) {
      if (oldVal != newVal) {
        this.genShowDeptList();
        this.genShowRelationList();
      }
    },
  },
  async mounted() {
    const { data } = await getDeptData();
    this.fullDeptList = data;
    this.queryInfo(this.cid);
  },

  methods: {

    async backToLogin() {
      this.$router.push({
        path: "/login",
        query: { redirectPath: "enquiry" },
      });
    },
    async backToStart() {
      this.$router.push("/start");
    },
    async queryInfo(cid) {
      try {
        const { data } = await enquiry(cid);
        if (data) {
          if (data.status == "login_require") {
            this.backToLogin();
            return;
          } else if (data.status == "ok") {
            this.profile.address = data.contact.address;
            this.profile.createDate = data.contact.createDate;
            this.profile.selectedDepts = this.fullDeptList.filter((x) =>
              data.depts.includes(x.id)
            );
            this.profile.relations = data.relations;
            this.cid = data.cid;
            await this.genShowDeptList();
            await this.genShowRelationList();
          }
        }
      } catch (e) {
        console.log(e);
        this.$message.error(this.$t("request_fail"));
      } finally {
        this.$nextTick(() => {
          this.loading = false;
        });
      }
    },
    async genShowDeptList() {
      const lang = getLocale();
      this.showDeptList = this.profile.selectedDepts.map((x) => ({
        id: x.id,
        text: x[lang + "name"],
      }));
    },
    async genShowRelationList() {
      const lang = getLocale();
      this.showRelationList = [];
      Object.keys(this.profile.relations).forEach((id) => {
        this.showRelationList.push({
          value: id,
          label:
            lang == "zh"
              ? this.profile.relations[id].cFullname
              : this.profile.relations[id].pFullname,
        });
      });
    },
    confirmPicker(option) {
      this.showPicker = false;
      if (option.value == this.cid) {
        return;
      }

      this.loading = true;
      this.queryInfo(option.value);
    },
  },
};
</script>
<style scoped>
p[class="label"] {
  color: #6c6c6c;
  margin-left: 10px;
}

.participant-dialog .el-dialog {
  max-width: 700px !important;
}
</style>

<style lang="scss">
.name-card-panel{
}
.el-dialog {
  max-width: 700px;
}


.enquiry-card {
  box-shadow: none;
  border: 1px solid rgba(19, 160, 123, .5);

  .el-input .el-input__inner,
  .el-textarea__inner {
    border: none;
    background-color: rgba(232, 242, 242, .8);
    border-radius: 32px;
    margin-bottom: 10px;
    padding: 10px 24px;
    color: #13a07b;
    font-size: 18px;
  }

  .el-input .el-input__inner {
    height: 44px;
  }

  .el-textarea__inner {
    height: 60px;
  }

  .dept-list {
    list-style-type: disc;
    margin-left: 40px;
  }

  .dept-list-box {
    background-color: rgba(232, 242, 242, .8);
    color: #13a07b;
  }
}
</style>

